export const COURSE_LEVELS = [
  "A1",
  "A2",
  "B1",
  "B2",
  "C1",
  "Konversationskurs",
  "Grammatikkurs",
];

export const PLACEMENT_COURSE_LEVELS = ["A1", "A2", "B1", "B2", "C1"];

export const SPECIAL_COURSE_LEVELS = ["Konversationskurs", "Grammatikkurs"];

export const getCourseLevelLabel = (t, level) => {
  if (!level) return "";
  return t(`courseLevels.${level}`, level);
};
